// extracted by mini-css-extract-plugin
export default {"copy-field":"dC8pxpsxC9h6n7Ox2vIF","copy-field-label":"MD1qyiMQ1GnnOAoNhYTj"};